export const statuses = {
  bug: 0,
  draft: 1,
  added: 2,
  changed: 3,
  deleted: 4,
  restored: 5,
  rejected: 6,
  amended: 7,
  addedApproved: 8,
  changedApproved: 9,
  deletedApproved: 10,
  hourlyLinked: 11,

  0: "There is a bug, please contact support",
  1: "Draft",
  2: "Added",
  3: "Changed",
  4: "Deleted",
  5: "Restored",
  6: "Rejected",
  7: "Amended > Approved",
  8: "Added > Approved",
  9: "Changed > Approved",
  10: "Deleted > Approved",
  11: "Hourly",
};

export const roles = {
  sysAdmin: 1,
  tollAdmin: 2,
  tollManager: 3,
  ownerDriver: 4,
  tollSystemAdmin: 5,

  1: "System Administrator",
  2: "TGE Administrator",
  3: "TGE Manager",
  4: "Owner Driver",
  5: "TGE System Administrator",
};

export function getApprovalState(roleId, action, currentStatus, dataType) {
  console.log(roles[roleId], action, statuses[currentStatus], dataType);
  switch (action) {
    case "CREATE_ITEM":
      if (roleId === roles.tollAdmin) {
        return statuses.amended;
      }
      if (roleId === roles.ownerDriver) {
        return statuses.added;
      }
      return statuses.bug;

    case "UPDATE_ITEM":
      if (roleId === roles.tollAdmin) {
        return statuses.amended;
      }
      if (roleId === roles.ownerDriver) {
        if (currentStatus === statuses.added) {
          if (dataType === "lcl" || dataType === "parcel") {
            return statuses.added;
          } else if (
            dataType === "hourly" ||
            dataType === "linehaul" ||
            dataType === "linehaulFloating"
          ) {
            return statuses.changed;
          }
        }
        if (currentStatus === statuses.draft) {
          return statuses.changed;
        }
        if (currentStatus === statuses.changed) {
          return statuses.changed;
        }
      }
      return statuses.bug;

    case "APPROVE_ITEM":
      if (currentStatus === statuses.added) {
        return statuses.addedApproved;
      }
      if (currentStatus === statuses.changed) {
        return statuses.changedApproved;
      }
      if (currentStatus === statuses.deleted) {
        return statuses.deletedApproved;
      }
      return statuses.bug;

    case "DELETE_ITEM":
      if (roleId === roles.tollAdmin) {
        return statuses.deletedApproved;
      }
      if (roleId === roles.ownerDriver) {
        return statuses.deleted;
      }
      return statuses.bug;

    case "RESTORE_ITEM":
      return statuses.restored;
    // return statuses.bug;

    default:
      console.log("getApprovalState default clause");
      return statuses.bug;
  }
}

export const invoiceStatuses = {
  dpcIncomplete: 1,
  dpcPending: 2,
  unsubmitted: 3,
  submitted: 4,
  rejected: 5,
  adminApproved: 6,
  managerApproved: 7,
  na: 8,

  1: "DPC Incomplete",
  2: "DPC Pending",
  3: "Unsubmitted",
  4: "Submitted",
  5: "Rejected",
  6: "Admin Approved",
  7: "Manager Approved",
  8: "N/A",
};

export const linehaulTypes = {
  1: "Round Trip",
  2: "Fixed Trip",
  3: "Floating Trip",
  roundTrip: 1,
  fixedTrip: 2,
  floatingTrip: 3,
};

export const branchNames = {
  1: "Ashburton",
  2: "Auckland",
  3: "Blenheim",
  4: "Christchurch",
  5: "Cromwell",
  6: "Dargaville",
  7: "Dunedin",
  8: "Gisborne",
  9: "Greymouth",
  10: "Hamilton",
  11: "Hastings",
  12: "Invercargill",
  13: "Kaikohe",
  14: "Kaitaia",
  15: "Kerikeri",
  16: "Masterton",
  17: "Nelson",
  18: "New Plymouth",
  19: "Oamaru",
  20: "Palmerston North",
  21: "Queenstown",
  22: "Rotorua",
  23: "Taupo",
  24: "Tauranga",
  25: "Timaru",
  26: "Wanganui",
  27: "Wellington",
  28: "Whangarei",
};

export const invoiceStatusOptions = [
  { value: 1, label: "DPC Incomplete" },
  { value: 2, label: "DPC Pending" },
  { value: 3, label: "Unsubmitted" },
  { value: 4, label: "Submitted" },
  { value: 5, label: "Rejected" },
  { value: 6, label: "Admin Approved" },
  { value: 7, label: "Manager Approved" },
  { value: 8, label: "N/A" },
];

export const pageSize = 100;